module.exports = __webpack_public_path__ + "img/blueteamsInactive.70f96033.svg";